export default () => window.innerWidth < window.innerHeight
